import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the EquationDataProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/

//nur in apps.module.ts, dann ist Singleton, wenn auf der page import, aber nicht in @components auf der page

var result: number;

@Injectable()
export class EquationDataProvider {

  //constructor(public http: Http) {
    constructor() {
    console.log('Hello EquationDataProvider Provider');
   
  }



public setResult(value) {
    result = value;
  }

  public getResult() {
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/providers/equationdata/equationdata.ts